import { useEffect, useState } from "react";
import { subscribePublicCustomers } from "../../../components/firebase/firestore";

export default function usePublicCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError(false);
    return subscribePublicCustomers((items) => {
      setCustomers(items);
      setLoading(false);
    }, () => {
      setCustomers([]);
      setError(true);
      setLoading(false);
    });
  }, [attempt]);

  return { customers, loading, error, retry: () => setAttempt((value) => value + 1) };
}
